export const ANALYTICS_NOTES_MONTHLY = 'analyticsNotesMonthly';

export const ANALYTICS_NOTES_MONTHLY_ACTIONS_NAME = {
  searchForeignTradeTemplateData: `${ANALYTICS_NOTES_MONTHLY}/searchForeignTradeTemplateData`,
  searchForeignTradeTable: `${ANALYTICS_NOTES_MONTHLY}/searchForeignTradeTable`,
  searchExportStructureTable: `${ANALYTICS_NOTES_MONTHLY}/searchExportStructureTable`,
  searchImportStructureTable: `${ANALYTICS_NOTES_MONTHLY}/searchImportStructureTable`,
  searchExportProductsTable: `${ANALYTICS_NOTES_MONTHLY}/searchExportProductsTable`,
  searchImportProductsTable: `${ANALYTICS_NOTES_MONTHLY}/searchImportProductsTable`,
} as const;

export const ANALYTICS_NOTES_MONTHLY_MUTATIONS_NAME = {
  setForeignTradeTemplateData: `${ANALYTICS_NOTES_MONTHLY}/setForeignTradeTemplateData`,
  setForeignTradeTable: `${ANALYTICS_NOTES_MONTHLY}/setForeignTradeTable`,
  setExportStructureTable: `${ANALYTICS_NOTES_MONTHLY}/setExportStructureTable`,
  setImportStructureTable: `${ANALYTICS_NOTES_MONTHLY}/setImportStructureTable`,
  setExportProductsTable: `${ANALYTICS_NOTES_MONTHLY}/setExportProductsTable`,
  setImportProductsTable: `${ANALYTICS_NOTES_MONTHLY}/setImportProductsTable`,
} as const;

export const ANALYTICS_NOTES_MONTHLY_GETTERS_NAME = {
  getForeignTradeTemplateData: `${ANALYTICS_NOTES_MONTHLY}/getForeignTradeTemplateData`,
  getForeignTradeTable: `${ANALYTICS_NOTES_MONTHLY}/getForeignTradeTable`,
  getExportStructureTable: `${ANALYTICS_NOTES_MONTHLY}/getExportStructureTable`,
  getImportStructureTable: `${ANALYTICS_NOTES_MONTHLY}/getImportStructureTable`,
  getExportProductsTable: `${ANALYTICS_NOTES_MONTHLY}/getExportProductsTable`,
  getImportProductsTable: `${ANALYTICS_NOTES_MONTHLY}/getImportProductsTable`,
} as const;
